// extracted by mini-css-extract-plugin
export default {"goldenImgContainer":"GoldenTag_goldenImgContainer__FQj24"};